import { render, staticRenderFns } from "./MpesaTransactions.vue?vue&type=template&id=9dead704&scoped=true"
import script from "./MpesaTransactions.vue?vue&type=script&lang=js"
export * from "./MpesaTransactions.vue?vue&type=script&lang=js"
import style0 from "./MpesaTransactions.vue?vue&type=style&index=0&id=9dead704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dead704",
  null
  
)

export default component.exports